import type { IEndpoint } from '../../types';

import { playerConfigParser } from './parsers';
import type { IPlayerConfigResponse, ParserOptions, PlayerConfigType } from './types';

export const playerConfigEndpoint: IEndpoint<PlayerConfigType, ParserOptions> = {
  url: '/api/config/preferences',
  parser: (rawResponse, options): PlayerConfigType =>
    playerConfigParser(rawResponse as IPlayerConfigResponse, options).parsedConfig,
  format: 'json',
};
